export default {
	tooLongDescriptionError: "Das Feld \"{0}\" darf nicht länger als 255 Zeichen sein.",
	fieldIsRequiredError: "Das Feld \"{0}\" ist erforderlich.",
	retypePasswordError: "Falsch eingegebenes Passwort.",

	permissionLevelRequiredError: "Das Feld \"Berechtigungsstufe\" ist erforderlich.",
	addToIssue: "Zur Ausgabe hinzufügen",
	dataSets: "Datensätze",
	businessProcesses: "Geschäftsprozesse",
	resource: "Ressource",
	period: "Zeitraum",
	authorizationLevel: "Berechtigungsstufe",
	currentAuthorizations: "Aktuelle Berechtigungen",

	warningEmployeeChangeTitle: "Benutzerwechsel, auf den sich die Anwendung bezieht",
	warningEmployeeChangeText: "Möchten Sie wirklich zu {0} wechseln? Der gesamte Umfang wird entfernt.",
	selectEmployee: "Mitarbeiter auswählen",
	authorizationControlHasChanges: "Die Berechtigungsprüfung hat Daten zum Anwendungsbereich ergänzt, die nicht ergänzt wurden.",

	editing: "Bearbeitung",
	copying: "Kopieren",
	copy: "Kopieren",
	accept: "Annehmen",
	reject: "Ablehnen",

	selectApplication: "Anwendung auswählen",
	selectService: "Dienst auswählen",
	selectDataSet: "Datensatz auswählen",
	selectBusinessProcess: "Geschäftsprozess auswählen",

	name: "Name",
	sapId: "SAP Id",
	hrId: "HR Id",
	applicationName: "Anwendungsname",
	type: "Typ",
	status: "Status",
	city: "Stadt",
	company: "Gesellschaft",
	riskLevel: "Risikostufe",
	department: "Abteilung",

	administrativeRole: "Administrative Rolle",
	sensitiveData: "Sensible Daten",
	reasonForProcessingSensitiveData: "Der Grund für die Verarbeitung sensibler Daten",
	acceptCheckboxLabel: "Ich habe den obigen Text gelesen und verstanden",

	step: "Schritt",
	of: "von",
}